<template>
    <layout-gestao>
    	<div class="row">
			<div class="col-sm-12">
				<form autocomplete="off" method="post" data-vv-scope="form" @keyup.enter="saveItem" @submit.prevent="">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8">
                            <div class="form-group">
                                <MaterialInput
									:readonly="readonlyFormItem"
									type="text" class="city-form-group city-bg"
									id="input-name"
									name="name"
									v-model.trim="form.name"
									v-validate="'required|min:3'"
									:inputClasses="[{'is-invalid': fnHasError('name') }]"
									:error=" fnFirstError('name')">
									{{ $t(`${pageID}.model.name`) }}
								</MaterialInput>
                            </div>
                        </div>
						<div class="col-sm-4">
                            <div class="form-group">
                                <MaterialSelect
									:disabled="readonlyFormItem"
									class="city-form-group city-bg"
									id="input-air_base_type_id"
									name="air_base_type_id"
									label="name"
									:filterable="true"
									:options="lists.air_base_types"
									v-model.trim="form.air_base_type_id"
									v-validate="'required'"
									:reduceObject="false"
									:inputClasses="[{'is-invalid': fnHasError('air_base_type_id') }]"
									:error=" fnFirstError('air_base_type_id')">
									{{ $t(`${pageID}.model.air_base_type`) }}
								</MaterialSelect>
                            </div>
                        </div>
						<div class="col-sm-4">
                            <div class="form-group">
                                <MaterialSelect
									:disabled="readonlyFormItem"
									class="city-form-group city-bg"
									id="input-district_id"
									name="district_id"
									label="name"
									:filterable="true"
									:options="lists.districts"
									v-model.trim="form.district_id"
									v-validate="'required'"
									:reduceObject="false"
									:inputClasses="[{'is-invalid': fnHasError('district_id') }]"
									:error=" fnFirstError('district_id')">
									{{ $t(`${pageID}.model.district`) }}
								</MaterialSelect>
                            </div>
                        </div>
						<div class="col-sm-8">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-address"
                                    name="address"
                                    v-model.trim="form.address"
                                    v-validate="'min:3'"
                                    :inputClasses="[{'is-invalid': fnHasError('address') }]"
                                    :error=" fnFirstError('address')">
                                    {{ $t(`${pageID}.model.address`) }}
                                </MaterialInput>
                            </div>
                        </div>

						<div class="col-sm-4">
                            <div class="form-group">
                                <MaterialInput
									:readonly="readonlyFormItem"
									type="text" class="city-form-group city-bg"
									id="input-decir"
									name="decir"
									v-model.trim="form.decir"
									v-validate="'required|min:3'"
									:inputClasses="[{'is-invalid': fnHasError('decir') }]"
									:error=" fnFirstError('decir')"
									:helpText="$t(`${pageID}.help.decir`)">
									{{ $t(`${pageID}.model.decir`) }}
								</MaterialInput>
                            </div>
                        </div>
						<div class="col-sm-8 col-lg-6">
							<div class="form-group">
								<MaterialInput
									:readonly="readonlyFormItem"
									type="text"
									class="city-form-group city-bg"
									id="input-phone"
									name="phone"
									v-model.trim="form.phone"
									v-validate="'phones'"
									:inputClasses="[{'is-invalid': fnHasError('phone') }]"
									:error="fnFirstError('phone')"
									:helpText="$t(`${pageID}.help.phone`)">
									{{ $t(`${pageID}.model.phone`) }}
								</MaterialInput>
							</div>
						</div>
						<div class="col-sm-2">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-active"
                                    name="active"
                                    label="name"
                                    :filterable="true"
                                    :options="lists.onoff"
                                    v-model.trim="form.active"
                                    :reduce="option => option.code"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('active') }]"
                                    :error=" fnFirstError('active')">
                                    {{ $t(`${pageID}.model.active`) }}
                                </MaterialSelect>
                            </div>
                        </div>

						<div class="col-sm-5 col-lg-4">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-lat"
                                    name="lat"
                                    v-model.trim="form.lat"
                                    v-validate="{lat:{checkDMS: true}}"
                                    :inputClasses="[{'is-invalid': fnHasError('lat') }]"
                                    :error="fnFirstError('lat')"
                                    :helpText="$t(`${pageID}.help.lat`)">
                                    {{ $t(`${pageID}.model.lat`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="col-sm-5 col-lg-4">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-lng"
                                    name="lng"
                                    v-model.trim="form.lng"
                                    v-validate="{lng:{checkDMS: true}}"
                                    :inputClasses="[{'is-invalid': fnHasError('lng') }]"
                                    :error="fnFirstError('lng')"
                                    :helpText="$t(`${pageID}.help.lng`)">
                                    {{ $t(`${pageID}.model.lng`) }}
                                </MaterialInput>
                            </div>
                        </div>

                    </div>
                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="saveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`)"/>
                </form>
			</div>
    	</div>
    </layout-gestao>
</template>

<script>
	import mixin from '../../mixin'

	export default {
		mixins: [mixin],
		data() {
			return {
				pageID: 'airbases',
				form: {
					id: null,
					name: null,
					air_base_type_id: null,
					phone: null,
					address: null,
					district_id: null,
					decir: null,
					lat: null,
					lng: null,
					active: 1,
				},
				lists: {
					loaded: false,
                    air_base_types: [],
                    districts: [],
                },
			}
		},
		mounted() {
			this.loadLists();
		},
		methods: {
        	loadLists: function() {
				if (!this.lists.loaded && this.url.getLists) {
					this.$http.get(this.formatString(this.url.getLists))
					.then(res => {
						let data = res.data ? res.data : res;
						Object.keys(data).forEach(key => {
							if(key in this.lists) {
								this.lists[key] = data[key];
							}
						});
						this.lists.loaded = true;
					})
					.catch(error => {
						this.lists.loaded = false;
						this.showHttpError(error);
					})
				}
			},
		},
	}
</script>
